import React, { useEffect, useState, useRef } from 'react';
import { getDatabase, ref, onChildAdded, query, orderByChild, remove } from 'firebase/database';
import dayjs from 'dayjs';

// assume firebase app is initialized elsewhere; just get the database
const db = getDatabase();

const ChatBubble = ({ message, sentBy, timestamp }) => {
  let background = '#f0f0f0';
  let justify = 'flex-start';
  let authorLabel = sentBy;

  if (sentBy.toLowerCase() === 'user') {
    background = '#d1d1d1';
    justify = 'flex-start';
  } else if (sentBy.toLowerCase() === 'yanglan bot') {
    background = '#ffe066';
    justify = 'flex-end';
  } else if (sentBy.toLowerCase() === 'bingyu bot') {
    background = '#c0e7ff';
    justify = 'flex-end';
  } else {
    background = '#ffd6e7';
    justify = 'flex-end';
  }

  const normalizedMessage = message?.replace(/\\n/g, '\n');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: justify,
        padding: '4px 8px',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          maxWidth: '75%',
          background,
          borderRadius: 12,
          padding: '10px 14px',
          position: 'relative',
          fontSize: 14,
          lineHeight: 1.4,
          wordBreak: 'break-word',
          boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
        }}
      >
        <div style={{ marginBottom: 4, fontWeight: 600, fontSize: 12, opacity: 0.85 }}>
          {authorLabel}
        </div>
        <div
            style={{
                whiteSpace: 'pre-wrap', // respects newlines and wraps
                wordBreak: 'break-word',
            }}
            >
            {normalizedMessage}
        </div>
        <div
          style={{
            marginTop: 6,
            fontSize: 10,
            textAlign: 'right',
            opacity: 0.6,
          }}
        >
          {dayjs(timestamp).format('HH:mm:ss')}
        </div>
      </div>
    </div>
  );
};

const MBTestChatScreen = ({ chatId }) => {
  const [messages, setMessages] = useState([]);
  const scrollRef = useRef(null);
  const seen = useRef(new Set());

  useEffect(() => {
    if (!chatId) return;
    const histRef = query(ref(db, `ai_testing/${chatId}`), orderByChild('timestamp'));

    const listener = onChildAdded(histRef, (snap) => {
      if (!snap.exists()) return;
      const key = snap.key;
      if (seen.current.has(key)) return; // dedupe
      seen.current.add(key);
      const val = snap.val();
      setMessages((prev) => {
        const combined = [...prev, { key, ...val }];
        // sort by timestamp so late arrivals don't misorder
        combined.sort((a, b) => {
          const ta = a.timestamp || a.time || '';
          const tb = b.timestamp || b.time || '';
          return ta.localeCompare(tb);
        });
        return combined;
      });
    });

    return () => {
      listener && listener(); // unsubscribe
    };
  }, [chatId]);

  useEffect(() => {
    if (scrollRef.current) {
     // scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      background: '#f5f7fa',
      fontFamily: 'system-ui,-apple-system,BlinkMacSystemFont,sans-serif',
    }}
  >
    <div
      style={{
        padding: '12px 16px',
        borderBottom: '1px solid #e2e8f0',
        background: '#fff',
        fontWeight: 700,
        fontSize: 18,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div>AI model chat</div>
      {<button
        onClick={async () => {
          if (!chatId) return;
          const confirmed = window.confirm('Clear all messages? This cannot be undone.');
          if (!confirmed) return;
          try {
            await remove(ref(db, `ai_testing/${chatId}`));
            setMessages([]);
          } catch (err) {
            console.error('Failed to clear chat:', err);
          }
        }}
        style={{
          background: '#e53e3e',
          color: '#fff',
          border: 'none',
          padding: '6px 12px',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: 14,
        }}
      >
        Clear All
      </button>}
    </div>
    <div
      ref={scrollRef}
      style={{
        flex: 1,
        overflowY: 'auto',
        padding: '12px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      {messages.map((m) => (
        <ChatBubble
          key={m.key}
          message={m.message}
          sentBy={m.sentBy}
          timestamp={m.timestamp || m.time || new Date().toISOString()}
        />
      ))}
    </div>
  </div>
  );
};

export default MBTestChatScreen;